/**
 * Convertit la valeur d'un attribut data-anim-scrub en option ScrollTrigger.
 *
 * - absent            → false (pas de scrub)
 * - présent sans valeur → true
 * - valeur numérique   → lissage du scrub (ex: data-anim-scrub="1")
 */
export default function parseScrub(raw) {
	if (raw === undefined) return false;
	if (raw === "") return true;
	const value = parseFloat(raw);
	return isNaN(value) ? true : value;
}
